import { useEffect } from "react";

interface Cinema8EmbedProps {
  mediaId?: string;
  className?: string;
}

const Cinema8Embed = ({ mediaId = "6JM9MM8J", className = "" }: Cinema8EmbedProps) => {
  useEffect(() => {
    if (!document.querySelector('script[src*="cinema8.com/embed/player.js"]')) {
      const script = document.createElement("script");
      script.src = "https://static-01.cinema8.com/embed/player.js";
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className={`relative w-full ${className}`} style={{ paddingTop: "56.25%" }}>
      <cinema8-player
        media-id={mediaId}
        autoplay="false"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default Cinema8Embed;
